import { render, staticRenderFns } from "./contract-device-onboard-qr.vue?vue&type=template&id=4825f244&scoped=true"
import script from "./contract-device-onboard-qr.vue?vue&type=script&lang=js"
export * from "./contract-device-onboard-qr.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=4825f244&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825f244",
  null
  
)

export default component.exports